import type { OpenModelDeleteProps } from "./model-delete.type";
import type { ModelItem } from "@/modules/model";

import { useTranslation } from "react-i18next";

import { useSidePanel } from "@/modules/side-panel";

import ModelDeleteContent from "./model-delete-content";

export const useModelDelete = () => {
  const { t } = useTranslation();
  const { openSidePanel } = useSidePanel();

  const openDelete = <Item extends ModelItem>({
    title,
    ...props
  }: OpenModelDeleteProps<Item>) => {
    openSidePanel({
      title: title ?? t("global:delete"),
      component: <ModelDeleteContent {...props} />,
    });
  };

  return {
    openDelete,
  };
};
